import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  setCart
} from "src/features/checkout/checkoutSlice"
import { useCartBuyerIdentityUpdateMutation } from "src/features/checkout/storefrontCartApi"

const useUpdateEmailAndShippingAddress = () => {
  const dispatch = useDispatch()
  const cart = useSelector((state) => state.checkout.cart)
  const { zip, zipData } = useSelector((state) => state.checkout.options)

  const [cartBuyerIdentityUpdate, {
    isLoading: cartBuyerIdentityUpdateLoading,
    data: cartBuyerIdentityUpdateData,
    error: cartBuyerIdentityUpdateError,
  }] = useCartBuyerIdentityUpdateMutation()

  const updateEmailAndShippingAddress = async ({ email, shippingAddress }) => {
    await cartBuyerIdentityUpdate({ cartId: cart.id, buyerIdentity: {
      email,
      deliveryAddressPreferences: {
        deliveryAddress: shippingAddress,
        oneTimeUse: true
      }
    }})
  }

  useEffect(() => {
    if (cartBuyerIdentityUpdateData?.cartBuyerIdentityUpdate?.cart) {
      dispatch(setCart(cartBuyerIdentityUpdateData?.cartBuyerIdentityUpdate?.cart));
    }
  }, [cartBuyerIdentityUpdateData])

  useEffect(() => {
    if (
      cart.buyerIdentity?.email &&
      cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.firstName &&
      cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.lastName &&
      cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.address1 &&
      cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.phone &&
      zipData &&
      zip
    ) {
      if (
        cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.city !== zipData.city ||
        cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.province !== zipData.province ||
        cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.zip !== zip
      ) {
        // Update checkout shipping address automatically if city, province or zip has been updated when switching checkout options.
        console.log('auto updateEmailAndShippingAddress', {
          email: cart.buyerIdentity.email,
          shippingAddress: {
            ...cart.buyerIdentity?.deliveryAddressPreferences?.[0],
            city: zipData.city,
            province: zipData?.province,
            zip,
          },
          cartBuyerIdentityUpdateData
        })
        updateEmailAndShippingAddress({
          email: cart.buyerIdentity.email,
          shippingAddress: {
            ...cart.buyerIdentity?.deliveryAddressPreferences?.[0],
            city: zipData.city,
            province: zipData?.province,
            zip,
          },
        })
      }
    }
  }, [])

  return [
    updateEmailAndShippingAddress,
    {
      isLoading: cartBuyerIdentityUpdateLoading,
      data: cartBuyerIdentityUpdateData,
      error: cartBuyerIdentityUpdateError,
    },
  ]
}

export default useUpdateEmailAndShippingAddress
